// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aggregations_md4Iu {
    flex-grow: 1;
}

.aggregation_Jmaf_ {
    position: relative;
}

.loading_w3HAu {
    height: 90px;
    width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reverse_DeboS {
    flex-direction: row-reverse !important;
}

.container_sKjEL {
    padding: 10px;
}

.toolbar_WfOgN {
    min-width: 40px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/aggregations/AggregationView.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".aggregations {\n    flex-grow: 1;\n}\n\n.aggregation {\n    position: relative;\n}\n\n.loading {\n    height: 90px;\n    width: 90px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.reverse {\n    flex-direction: row-reverse !important;\n}\n\n.container {\n    padding: 10px;\n}\n\n.toolbar {\n    min-width: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aggregations": `aggregations_md4Iu`,
	"aggregation": `aggregation_Jmaf_`,
	"loading": `loading_w3HAu`,
	"reverse": `reverse_DeboS`,
	"container": `container_sKjEL`,
	"toolbar": `toolbar_WfOgN`
};
export default ___CSS_LOADER_EXPORT___;
